import React from 'react';

import { ProPlanId } from '../../constants/premium';
import { formatBillingFrequency, formatOfferDuration } from '../../helpers/premium';
import { ICoupon } from '../../interfaces/stripe';
import { Button } from '../Clickables/Buttons/Button';
import { InternalLink } from '../Clickables/InternalLink/InternalLink';
import { Heading } from '../Heading/Heading';
import { getPaymentPlans } from '../ProPaymentPlans/helpers';
import { Text } from '../Text/Text';

interface IProps {
  selectedPlanId?: ProPlanId;
  coupon?: ICoupon;
  couponIsLoading?: boolean;
  submitLink?: string;
  onSubmitLinkClick?: () => void;
}

export const StickyBannerGetPro = ({
  selectedPlanId,
  coupon,
  couponIsLoading = false,
  submitLink,
  onSubmitLinkClick,
}: IProps) => {
  const paymentPlans = getPaymentPlans(coupon);
  const filteredPlanList = paymentPlans.filter(plan => plan.planID === selectedPlanId);
  const selectedPlan = filteredPlanList[0];

  return (
    <>
      {!couponIsLoading && selectedPlan && (
        <div
          className="z-high border-twilight sticky bottom-0 overflow-x-visible border-t bg-white px-6 py-5 shadow-xl sm:absolute sm:inset-x-0"
          data-testid="StickyBannerGetPro"
        >
          <div className="flex max-w-(--breakpoint-md) flex-row items-center justify-between sm:px-8">
            <div>
              <div>
                {coupon && (
                  <Text variant="sm" className="mb-0">
                    {formatOfferDuration(coupon)}
                  </Text>
                )}
                {selectedPlan.originalPrice && (
                  <>
                    <Heading variant="sm" as="span" className="line-through">
                      {selectedPlan.originalPrice}
                    </Heading>{' '}
                  </>
                )}
                <Heading
                  variant="sm"
                  as="span"
                  className={selectedPlan.originalPrice ? 'text-pinktail' : ''}
                >
                  {coupon ? selectedPlan.price : selectedPlan.pricePerMonth}
                </Heading>
                <Text variant="sm" as="span">
                  {' '}
                  {coupon ? formatBillingFrequency(coupon) : '/month'}
                </Text>
              </div>
              {!coupon && (
                <Text variant="sm" as="span">
                  &#42;when billed {selectedPlan.planDuration}
                </Text>
              )}
            </div>
            {submitLink ? (
              <InternalLink
                variant="buttonPro"
                to={submitLink}
                className="px-8"
                onClick={onSubmitLinkClick}
              >
                Continue
              </InternalLink>
            ) : (
              <Button className="px-8" variant="buttonPro" onClick={onSubmitLinkClick}>
                Continue
              </Button>
            )}
          </div>
        </div>
      )}
    </>
  );
};
